import { Spinner } from "@chakra-ui/spinner";
import { FC, PropsWithChildren } from "react";
import styles from "./Button.module.scss";

export interface ButtonProps {
  type?: "primary" | "secondary" | "tertiary";
  disabled?: boolean;
  onClick?: () => void;
  loading?: boolean;
  className?: string;
  loadingDisplayType?: "withText" | "iconOnly";
}

const Button: FC<PropsWithChildren<ButtonProps>> = ({
  type = "primary",
  disabled = false,
  children,
  onClick,
  loading,
  className,
  loadingDisplayType = "withText",
}) => (
  <button
    className={`${styles.button} ${styles[type]} ${
      loading ? styles.loading : ""
    } ${
      loading && loadingDisplayType === "iconOnly" ? styles.iconOnly : ""
    } ${className}`}
    disabled={disabled}
    onClick={onClick}
  >
    {!!loading && <Spinner color="#ffffff" />}
    {(!loading || (loading && loadingDisplayType === "withText")) && (
      <div>{children}</div>
    )}
  </button>
);

export default Button;
